<template>
  <div id="header">
    <nav class="navbar navbar-expand-md bg-primary navbar-dark header" id="header">
      <div class="container">
        <router-link :to="{name:'home-view'}" class="navbar-brand">
          <img src="../assets/brand.png" alt="genome23-logo">
        </router-link>

        <div id="menu" class="btn-group">
          <a class="btn btn-outline-light mr-sm-2 btn-sm dropdown-toggle" data-toggle="dropdown" href="#">
              {{get_language}}<span class="caret"></span>
          </a>
          <ul class="dropdown-menu">
            <a style="text-decoration:none" href="#">
              <li class="dropdown-item" @click="changeLanguage('en')">English</li>
            </a>
            <a style="text-decoration:none" href="#">
              <li class="dropdown-item" @click="changeLanguage('pl')">Polski</li>
            </a>
          </ul>
        </div>

        <button class="navbar-toggler" data-toggle="collapse" data-target="#navbarMenu">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarMenu">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <router-link :to="{name:'why-you-should-know-your-genome-view'}" class="nav-link text-nowrap">
                {{$t('navigation["why_you_should_know_your_genome"]')}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name:'how-it-works-view'}" class="nav-link text-nowrap">
                {{$t('navigation["how_it_works"]')}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name:'compare-packages-view'}" class="nav-link text-nowrap">
                {{$t('navigation["packages"]')}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name:'about-us-view'}" class="nav-link text-nowrap">
                {{$t('navigation["about_us"]')}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name:'faq-view'}" class="nav-link text-nowrap">
                {{$t('navigation["faq"]')}}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name:'contact-view'}" class="nav-link text-nowrap">
                {{$t('navigation["contact"]')}}
              </router-link>
            </li>
            <li class="nav-item d-none" v-if="!isLoggedIn">
              <router-link class="btn btn-outline-light mr-sm-2 btn-sm" :to="{name:'register-view'}"
                           id="register_collection_set_link">
                {{$t('register_button_label')}}
              </router-link>
            </li>

            <li class="nav-item log" v-if="isLoggedIn">
              <h4 class="text-user">{{$t('signed_in_as')}}</h4>
              <h3 class="text-id">{{user.registration_code}}</h3>
            </li>
            <li class="nav-item" v-if="isLoggedIn">
              <a href="#" class="btn btn-light mr-sm-2 btn-sm" @click="logout">Log-out</a>
            </li>

            <li class="nav-item d-none" v-if="!isLoggedIn">
              <router-link class="btn btn-light mr-sm-2 btn-sm" :to="{name:'login-view'}"
                           id="login_link">
                {{$t('sign_in_button_label')}}
              </router-link>
            </li>
          </ul>
          
        </div>
      </div>
    </nav>
  </div>

</template>

<script>
  import {HANDLE_LOGOUT, SET_LOCALE_A} from "../store/actions";
  import {mapGetters} from "vuex";

  export default {
    name: "Navigation",
    computed: {
      ...mapGetters(['isLoggedIn', 'userId', 'expireTime', 'user', 'get_language'])
    },
    methods: {
      changeLanguage: function (language) {
        this.$i18n.locale = language;
        this.$store.dispatch(SET_LOCALE_A, {lang: language}); // set state::locale to chosen language
      },
      logout: function () {
        this.$store.dispatch({
          type: HANDLE_LOGOUT
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue